<template>
    <div>
        <div class="form-group">
            <div class="col-12">
                <span class="general-header">
                    {{resource('TouchpointStatistics_Overview_Other_GeneralHeader')}}
                </span>
            </div>
        </div>

        <statistics-page v-if="statistics" :data="categories"/>

    </div>
</template>

<script>

import api from '@modules/JourneyBuilder/api'
import resources from '@core/Util/Mixins/resources';
import { bootstrapDangerGrowl } from '@core/Util/growler';

import StatisticsPage from './Page/StatisticsPage.vue';

export default {
    name: 'statistics-other',
    components: {
        StatisticsPage
    },
    mixins: [resources],
    created() {
        const vm = this;

        api.getTouchPointStatistics(vm.brickId).then(
            (statistics) => {
                vm.statistics = statistics;
            },
            bootstrapDangerGrowl
        );
    },
    computed: {
        categories() {
            return this.statistics.categories || [];
        }
    },
    data() {
        return {
            statistics: null
        }
    },
    props: {
        brickId: {
            type: String,
            required: true
        }
    }
}
</script>

<style scoped lang="scss">
	@import "~@modules/JourneyBuilder/Style/touchpoint-statistics.scss";
</style>